import React, { useState, useEffect } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import SearchContainer from '../SearchContainer/SearchContainer';
import { fetchCart } from '../../hook/cart';
import { changeLocal } from "../../hook/Localization";
import logo from "../../assets/darklogo.png";
import "./Navbar.css";
import enLang from "../../assets/lang.svg"
import arLang from "../../assets/egypt.png";
import { Col, Container, Dropdown, Offcanvas, Row } from 'react-bootstrap';
import { loginMethod } from '../../hook/auth';

function Navbar() {
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state);
  const cart = useSelector((state) => state.cartReducer.cart);
console.log(userinfo?.auth);
console.log(userinfo?.auth.userArray?.name);

  useEffect(() => {
    dispatch(fetchCart());
  }, [dispatch]);

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (!value) {
      setProducts([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://nanosoft.technology/outlaw/api/search?query=${value}`
      );
      setProducts(res?.data?.data?.results?.product?.items || []);
    } catch (error) {
      alert(Object.values(error?.response?.data?.errors || {})[0]?.[0] || "Search failed");
    }
  };
  const handleLang = () => { dispatch(changeLocal(currentLocal && currentLocal.language === "English" ? "ar" : "en")); }
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  return (
    <>
      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton className='border-0'>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className='h-100 d-flex flex-column justify-content-between'>
            <div className='media_nav_items_container'>
              <li className="footer_item" onClick={() => {
                navigate('/');
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" class="bi bi-house-door" viewBox="0 0 16 16">
                  <path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4z" />
                </svg>
                <p className="mb-0 mx-2">{currentLocal.home.home}</p>
              </li>
              <li className="footer_item" onClick={() => {
                navigate('/search');
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" class="bi bi-search" viewBox="0 0 16 16">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                </svg>
                <p className="mb-0 mx-2">{currentLocal.home.search}</p>
              </li>
              {/* <li className="footer_item" onClick={() => {
           navigate('/aboutus');
                }}>
                  <p className="mb-0 mx-4">{currentLocal.home.aboutus}</p>
                </li> */}
              {/* <li className="footer_item" onClick={() => {
           navigate('/contact');
                }}>
                  <p className="mb-0 mx-4">{currentLocal.home.contacttitle}</p>
                </li> */}
              {/* <li className="footer_item" onClick={() => {
         navigate('/exchange');
                }
                }>
                  <p className="mb-0 mx-4">{currentLocal.home.Exchange}</p>
                </li> */}
              {/* <li className="footer_item" onClick={() => {
         navigate('/privacy');
                }}>
                  <p className="mb-0 mx-4">{currentLocal.home.privacy}</p>
                </li> */}
              {/* <li className="footer_item" onClick={() => {
         navigate('/shipping');
                }}>
                  <p className="mb-0 mx-4 ">{currentLocal.home.shipping}</p>
                </li> */}
              {/* <li className="footer_item" onClick={() => {
         navigate('/terms');
                }}>
                  <p className="mb-0 mx-4 ">{currentLocal.home.terms}</p>
                </li> */}


              {/* <li className={userinfo?.auth?.access_token?"footer_item ":"footer_item border-0"} onClick={() => {navigate('/Product/Verify')}}>
                  <p className="mb-0 mx-4 ">{currentLocal.home.VerifyProduct}</p>
                </li> */}
              {userinfo?.auth?.access_token &&
                <li className="footer_item "
                  onClick={() => {

                    navigate("/account_setting");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="#fff"
                    className="bi bi-person"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                  </svg>
                  <p className="mb-0 mx-2">{currentLocal.home.profile}</p>
                </li>}
              {userinfo?.auth?.access_token &&
                <li className="footer_item"
                  onClick={() => {

                    navigate("/user/orders");
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-handbag" viewBox="0 0 16 16">
                    <path d="M8 1a2 2 0 0 1 2 2v2H6V3a2 2 0 0 1 2-2m3 4V3a3 3 0 1 0-6 0v2H3.36a1.5 1.5 0 0 0-1.483 1.277L.85 13.13A2.5 2.5 0 0 0 3.322 16h9.355a2.5 2.5 0 0 0 2.473-2.87l-1.028-6.853A1.5 1.5 0 0 0 12.64 5zm-1 1v1.5a.5.5 0 0 0 1 0V6h1.639a.5.5 0 0 1 .494.426l1.028 6.851A1.5 1.5 0 0 1 12.678 15H3.322a1.5 1.5 0 0 1-1.483-1.723l1.028-6.851A.5.5 0 0 1 3.36 6H5v1.5a.5.5 0 1 0 1 0V6z" />
                  </svg>
                  <p className="mb-0 mx-2 ">{currentLocal.home.myOrder}</p>
                </li>}
              {userinfo?.auth?.access_token &&
                <li className="footer_item"
                  onClick={() => {

                    navigate("/user/track_order");
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-sign-railroad" viewBox="0 0 16 16">
                    <path d="M11.303 6.584h1.064c.592 0 .936.334.936.844a.79.79 0 0 1-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521zm.521.414v.861h.46c.292 0 .474-.14.474-.421 0-.286-.188-.44-.467-.44zm-8.771-.414h1.064c.592 0 .936.334.936.844 0 .39-.242.654-.485.748l.536 1.074h-.59l-.467-.994h-.473v.994h-.521zm.521.414v.861h.46c.292 0 .474-.14.474-.421 0-.286-.188-.44-.467-.44z" />
                    <path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L4.923 3.861 8 6.939l3.078-3.077L8.35 1.134Zm3.788 3.788L9.061 8l3.077 3.078 2.728-2.728a.495.495 0 0 0 0-.7zm-1.06 7.215L8 9.061l-3.077 3.077 2.727 2.728a.495.495 0 0 0 .7 0zm-7.216-1.06L6.939 8 3.862 4.923 1.134 7.65a.495.495 0 0 0 0 .7z" />
                  </svg>
                  <p className="mb-0 mx-2 ">{currentLocal.home.trackingNumber}</p>
                </li>}
              {userinfo?.auth?.access_token &&
                <li className="footer_item"
                  onClick={() => {

                    navigate("/user/addressbook");
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                  </svg>
                  <p className="mb-0 mx-2 ">{currentLocal.home.trackingNumber}</p>
                </li>}
              {userinfo?.auth?.access_token &&
                <li className="footer_item border-0"
                  onClick={() => {
                    dispatch(loginMethod({
                      data: {},
                      access_token: ""
                    }))
                    navigate("/");
                  }}
                >
                  <p className="mb-0 mx-4 ">{currentLocal.home.logout}</p>
                </li>}















            </div>
            <div className='mb-5 pb-5'>
              {
                userinfo?.auth?.access_token ?
                  <li className="footer_item" onClick={() => {
                    navigate('/account_setting');
                  }}>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="currentColor"
                      className="bi bi-person"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                    </svg>
                    <p className="mb-0 mx-2">                  {currentLocal.home.WelcometoTaarteb}  {userinfo?.auth?.userArray?.user?userinfo?.auth?.userArray?.user?.name:userinfo?.auth.userArray?.name}
                    </p>

                  </li>
                  :
                  <li className="footer_item" onClick={() => {
                    navigate('/login');
                  }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="currentColor"
                      className="bi bi-person"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                    </svg>
                    <p className="mb-0 mx-2">{currentLocal.home.login} / {currentLocal.home.Registration}</p>
                  </li>
              }

              <div className='d-flex justify-content-center mt-4'>
        
                <a href='https://www.instagram.com/_outlaw_official' rel="noreferrer" target='_blank'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#fff" className="bi bi-instagram" viewBox="0 0 16 16">
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <div className='media_query py-4 px-3 bg-dark'>

        <Container >
          <Row>
            <Col>
              <div onClick={handleShow}>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#fff" class="bi bi-list" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
                </svg>
              </div>
            </Col>
            <Col>
              <div className='text-center'>
                <Link to="/">
                  <img src={logo} alt="Logo" className="w-100" />


                </Link>
              </div>
            </Col>
            <Col>

              <div className='d-flex justify-content-between align-items-center'>
                <div></div>
                <div>
                  {/* <div className="nav-item dropdown mx-3">
                  <Link className="nav-link dropdown-toggle d-flex justify-content-center align-items-center" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                      {currentLocal.language}

                    <img src={currentLocal && currentLocal.language === "العربيه" ? arLang : enLang} alt="" className="w-75 mx-1" />

                  </Link>
                  <ul className="dropdown-menu">
                    <li><div className="dropdown-item  d-flex align-items-center" onClick={handleLang}>
                      <img src={currentLocal && currentLocal.language === "العربيه" ? enLang : arLang} alt="" className="w-25 me-2" />

                      {currentLocal && currentLocal.language === "English" ? "العربيه" : "English"
                      }

                    </div></li>
                  </ul>
                </div> */}


                  {/* <div onClick={handleLang} className='d-flex align-items-center'>
                    <p className='mb-0 fw-bold'
                      style={{
                        color: "gray",
                        fontSize: "11px"
                      }}
                    >
                      {currentLocal.home.lang}

                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#fff" class="bi bi-globe" viewBox="0 0 16 16" className='mx-1'>
                      <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855A8 8 0 0 0 5.145 4H7.5zM4.09 4a9.3 9.3 0 0 1 .64-1.539 7 7 0 0 1 .597-.933A7.03 7.03 0 0 0 2.255 4zm-.582 3.5c.03-.877.138-1.718.312-2.5H1.674a7 7 0 0 0-.656 2.5zM4.847 5a12.5 12.5 0 0 0-.338 2.5H7.5V5zM8.5 5v2.5h2.99a12.5 12.5 0 0 0-.337-2.5zM4.51 8.5a12.5 12.5 0 0 0 .337 2.5H7.5V8.5zm3.99 0V11h2.653c.187-.765.306-1.608.338-2.5zM5.145 12q.208.58.468 1.068c.552 1.035 1.218 1.65 1.887 1.855V12zm.182 2.472a7 7 0 0 1-.597-.933A9.3 9.3 0 0 1 4.09 12H2.255a7 7 0 0 0 3.072 2.472M3.82 11a13.7 13.7 0 0 1-.312-2.5h-2.49c.062.89.291 1.733.656 2.5zm6.853 3.472A7 7 0 0 0 13.745 12H11.91a9.3 9.3 0 0 1-.64 1.539 7 7 0 0 1-.597.933M8.5 12v2.923c.67-.204 1.335-.82 1.887-1.855q.26-.487.468-1.068zm3.68-1h2.146c.365-.767.594-1.61.656-2.5h-2.49a13.7 13.7 0 0 1-.312 2.5m2.802-3.5a7 7 0 0 0-.656-2.5H12.18c.174.782.282 1.623.312 2.5zM11.27 2.461c.247.464.462.98.64 1.539h1.835a7 7 0 0 0-3.072-2.472c.218.284.418.598.597.933M10.855 4a8 8 0 0 0-.468-1.068C9.835 1.897 9.17 1.282 8.5 1.077V4z" />
                    </svg>
                  </div> */}

                </div>
                <div class=" position-relative dropdown d-flex justify-content-end">
                  <Link to={userinfo?.auth?.access_token ? "/cart" : "/login"} style={{}} >


                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" className="bi bi-cart2" viewBox="0 0 16 16">
                      <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l1.25 5h8.22l1.25-5zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
                    </svg>
                  </Link>
                  {userinfo?.auth?.access_token &&
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                      {cart?.items?.[0]?.products.length > 0 ? cart?.items?.[0]?.products.length : 0}
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  }
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className='lg_media_query bg-dark'>
        <div className="px-3 py-3">

          <div className='d-flex justify-content-between align-items-center'>
            <div className="nav_logo_container" onClick={() => {
              navigate("/")
            }}
              style={{ cursor: "pointer" }}
            >
              <img src={logo} alt="Logo" className="w-75" />
            </div>


            <div style={{ width: "30%", }}>
              <div className="w-100 position-relative">
                <input
                  placeholder={currentLocal?.home?.search || "Search..."}
                  className={
                    currentLocal?.language === "English"
                      ? "w-100 text-start h-100 py-1 py-2"
                      : "w-100 text-end h-100 py-1 px-2"
                  }
                  style={{ height: "40px" }}
                  value={searchValue}
                  onChange={handleSearch}
                />
                <div
                  className={
                    currentLocal?.language === "English"
                      ? "searsh_icon"
                      : "ar_searsh_icon"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="#000"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 
                  1.398h-.001q.044.06.098.115l3.85 
                  3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 
                  1 0 0 0-.115-.1zM12 
                  6.5a5.5 5.5 0 1 1-11 
                  0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                </div>

                {searchValue && (
                  <div
                    className={
                      currentLocal?.language === "English"
                        ? "search_input"
                        : "ar_search_input"
                    }
                  >
                    <SearchContainer
                      searchkey={searchValue}
                      products={products}
                      categories={categories}
                    />
                  </div>
                )}
              </div>

              {/* Quick Links */}

            </div>


            <div
              className='d-flex nav_links_tab justify-content-end'>
              <div className="dropdown">

                {userinfo?.auth?.access_token ? (
                  <Dropdown className='bg-dark'>
                    <Dropdown.Toggle
                      variant="dark"
                      id="dropdown-basic"
                      style={{
                        ...(location.pathname !== "/" && { color: "black" }),
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="#fff"
                        className="bi bi-person"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item as={Link} to="/account_setting">
                        {currentLocal.home.profile}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/orders">
                        {currentLocal.home.myOrder}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/track_order">
                        {currentLocal.home.trackingNumber}
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/user/addressbook">
                        {currentLocal.home.myAddresses}

                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          dispatch(loginMethod({
                            data: {},
                            access_token: ""
                          }))
                          navigate("/");
                        }}
                      >
                        {currentLocal.home.logout}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (


                  <div
                    style={{ marginTop: '7px' }}
                  >
                    <Link to="/login"
                      style={{
                        ...(location.pathname !== '/' && { color: "#000" })
                      }}
                    >

                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#fff" className="bi bi-person" viewBox="0 0 16 16">
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                      </svg>
                    </Link>
                  </div>

                )}

              </div>


              <div class=" position-relative dropdown d-flex">
                <Link to={userinfo?.auth?.access_token ? "/cart" : "/login"} style={{ marginTop: '7px' }} className='ms-3'>


                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" className="bi bi-cart2" viewBox="0 0 16 16">
                    <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l1.25 5h8.22l1.25-5zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
                  </svg>
                </Link>
                {userinfo?.auth?.access_token &&
                  <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {cart?.items?.[0]?.products.length > 0 ? cart?.items?.[0]?.products.length : 0}
                    <span class="visually-hidden">unread messages</span>
                  </span>
                }
              </div>

              <div>
                {/* <div className="nav-item dropdown mx-3">
                  <Link className="nav-link dropdown-toggle d-flex justify-content-center align-items-center" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src={currentLocal && currentLocal.language === "العربيه" ? arLang : enLang} alt="" className="w-75" />

                    {currentLocal.language}
                  </Link>
                  <ul className="dropdown-menu">
                    <li><div className="dropdown-item  d-flex align-items-center" onClick={handleLang}>
                      <img src={currentLocal && currentLocal.language === "العربيه" ? enLang : arLang} alt="" className="w-25 me-2" />

                      {currentLocal && currentLocal.language === "English" ? "العربيه" : "English"
                      }

                    </div></li>
                  </ul>
                </div> */}




              </div>
            </div>






          </div>



        </div>
      </div>
    </>
    // <div className="mx-3 my-3">
    //   {/* Logo */}
    //   <div className='d-flex justify-content-between align-items-center'>
    //     <div className='nav_logo_container'>
    // <div className="w-100">
    //   <img src={logo} alt="Logo" className="w-100" />
    // </div>

    //       {/* Mobile Menu */}
    //       <div className="media_query">
    //     <div className='media_query_search'>fdskfjs</div>

    //   </div>

    // </div>
  );
}

export default Navbar;
